<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="4">
        <el-text-field
          :need="!registracijaDisabled"
          label="Dizaino registracijos numeris"
          tooltip="Hipoteka. Turtas. Dizainas. Dizaino registracijos numeris"
          :counter="100"
          :readonly="turtasReadonly"
          :disabled="registracijaDisabled"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly"
        />
      </v-col>
      <v-col cols="12" md="3">
        <el-checkbox
          class="mb-3 mt-3"
          label="Neregistruotas"
          tooltip="Hipoteka. Turtas. Dizainas. Dizaino registracijos numeris neregistruotas"
          :readonly="turtasReadonly"
          v-model="neregistruotas"
        />
      </v-col>
      <v-col cols="12" md="5">
        <el-text-field
          need
          label="Paraiškos numeris"
          tooltip="Hipoteka. Turtas. Dizainas. Paraiškos numeris"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_vpb_paraiska"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasDizainas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      neregistruotas: false,
    }
  },
  watch: {
    neregistruotas(val) {
      if (val) {
        this.formData.tur_identifikatorius = null
      }
      this.formData.tur_vpb_neregistruotas = val
    },
  },
  created() {
    this.neregistruotas = this.formData.tur_vpb_neregistruotas ?? false
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
    registracijaDisabled() {
      return this.neregistruotas
    },
  },
  created() {
    this.neregistruotas = this.formData.tur_vpb_neregistruotas
  },
}
</script>
